import { GoogleMap, Marker, DirectionsRenderer } from "@react-google-maps/api";
import { useEffect, useState } from "react";

const defaultCenter = { lat: -37.8136, lng: 144.9631 }; // Melbourne

export default function DriverMap({ addresses, onMapClick }) {
  const [directions, setDirections] = useState(null);
  const [center, setCenter] = useState(defaultCenter);
  const [singleMarker, setSingleMarker] = useState(null);

  useEffect(() => {
    if (typeof window === "undefined" || !window.google?.maps) return;

    if (!addresses || addresses.length === 0) {
      console.warn("🛑 No addresses provided to DriverMap.");
      return;
    }

    const cleaned = addresses
      .map((item) => (typeof item === "string" ? item.trim() : item?.address?.trim()))
      .filter((addr) => {
        const valid = addr && addr.length > 5;
        if (!valid) console.warn("⚠️ Invalid address skipped:", addr);
        return valid;
      });

    if (cleaned.length === 0) {
      console.warn("🛑 No valid addresses for map rendering.");
      return;
    }

    if (cleaned.length === 1) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: `${cleaned[0]}, Australia` }, (results, status) => {
        if (status === "OK" && results[0]) {
          const loc = results[0].geometry.location;
          const latLng = { lat: loc.lat(), lng: loc.lng() };
          setCenter(latLng);
          setSingleMarker(latLng);
          setDirections(null);
        } else {
          console.error("❌ Geocoding failed:", status);
        }
      });
      return;
    }

    const service = new window.google.maps.DirectionsService();
    const origin = cleaned[0];
    const destination = cleaned[cleaned.length - 1];
    const waypoints = cleaned.slice(1, -1).map((addr) => ({ location: addr, stopover: true }));

    service.route(
      {
        origin,
        destination,
        waypoints,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === "OK") {
          setDirections(result);
          setCenter(result.routes[0].bounds.getCenter().toJSON());
          setSingleMarker(null);
        } else {
          console.error("❌ Directions failed:", status);
        }
      }
    );
  }, [addresses]);

  const handleMapClick = (e) => {
    if (!onMapClick) return;
    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        const address = results[0].formatted_address;
        onMapClick({ lat, lng, address });
      } else {
        console.error("❌ Reverse geocoding failed:", status);
      }
    });
  };

  return (
    <GoogleMap
      mapContainerStyle={{ width: "100%", height: "300px" }}
      center={center}
      zoom={13}
      onClick={handleMapClick}
    >
      {directions && <DirectionsRenderer directions={directions} />}
      {!directions && singleMarker && <Marker position={singleMarker} label="1" />}
    </GoogleMap>
  );
}